export const aboutMeInfo = `Self-taught freelance web developer loves web development with the latest technologies. My expertise is in web development with JavaScript, ReactJS, NodeJS. I love writing software with simplicity in mind and attracted to solve real-world problems. I'm looking for a role where I can use my expertise and solve real-world problems eloquently. Have a long term vision to improve and bring value to the organization through dedication and constant learning.`;

export const educations = [
  {
    college: 'Siddaganga Institute of Technology, Tumkur',
    course: 'M.Tech, Thermal Power Engineering',
    period: '2017 - 2019',
  },
  {
    college: 'Government Engineering College, Ramanagara',
    course: 'BE, Mechanical Engineering',
    period: '2013 - 2017',
  },
];

export const skills = [
  {
    name: 'VSCode',
    logo: require('../assets/images/vscode-icon.png'),
  },
  {
    name: 'ES6',
    logo: require('../assets/images/es6.png'),
  },
  {
    name: 'Express.js',
    logo: require('../assets/images/expressjs.svg'),
  },
  {
    name: 'Gatsby.js',
    logo: require('../assets/images/gatsbyjs-icon.svg'),
  },
  {
    name: 'Jest',
    logo: require('../assets/images/jestlogo.png'),
  },
  {
    name: 'MERN Stack',
    logo: require('../assets/images/mern.png'),
  },
];

export const progLanguages = [
  {
    name: 'JavaScript',
    logo: require('../assets/images/icons8-javascript-48.png'),
  },
  {
    name: 'NodeJS',
    logo: require('../assets/images/nodejs-icon.svg'),
  },
  {
    name: 'React',
    logo: require('../assets/images/icons8-react-50.png'),
  },
  {
    name: 'HTML5',
    logo: require('../assets/images/icons8-html-5-48.png'),
  },
  {
    name: 'CSS3',
    logo: require('../assets/images/icons8-css3-48.png'),
  },
];

export const internship = [
  {
    place: 'Intern at CGPL Indian Institute of Science, Bengaluru',
    topic:
      'Internship on modelling and analysis of 2D and 3D supersonic rectangular and axis symmetric ramjet intake at Mach number 3, by using NX software, ICEM meshing and CFX solver at Mach number 3.',
    period: 'Sep-2018 - Dec-2018',
  },
];

export const project = [
  {
    title:
      'Responsive web page using latest technologies like ReactJS, HTML & CSS.',
    description: 'URL: https://sachingowdaac.netlify.app/',
  },
];
